import { PatientFileVersion } from "../../../../amplify/api-gateway/query";
import { PatientVisit } from "../../../../amplify/api-gateway/search-patients";
import VersionSelectModal from "./VersionSelectModal";

export const LLMDashboardUpdated = (props: {
    patient: PatientVisit,
    statuses: any,
    handleShowScanMultiModal?: any,
    latestFileVersions: Record<string, PatientFileVersion>,
    handleFileVersionChange: (fileType: string, fv: PatientFileVersion, prevFv: PatientFileVersion | null) => void;
    explainKey: string,
    sectionToSetter?: any,
}) => {

    return (
        <span className="notes-metadata">
            Updated {props.latestFileVersions && props.latestFileVersions[props.explainKey] && props.statuses[props.explainKey] && props.statuses[props.explainKey].last_sync_timestamp && <VersionSelectModal handleFileVersionChange={props.handleFileVersionChange} defaultPatientFileVersion={props.latestFileVersions[props.explainKey]} sectionToSetter={props.sectionToSetter} patient={props.patient} fileType={props.explainKey} />}{props.handleShowScanMultiModal && props.latestFileVersions && props.latestFileVersions[props.explainKey] && (<>{' '}with <span className="notes-highlight notes-highlight-green" onClick={() => { props.handleShowScanMultiModal(props.latestFileVersions[props.explainKey]) }}>{props.latestFileVersions[props.explainKey].source_changed_keys ? props.latestFileVersions[props.explainKey].source_changed_keys.length : ""} new data</span></>)}</span>
    );
};
